module.exports = __webpack_public_path__ + "static/media/Layer-11.99fb7fac.png";